const index = () => import(/* webpackChunkName: "marketing" */ '../views/message-center/index.vue')

export default [
    {
        path: '/message-center',
        name: 'message-center',
        meta: {
            name: '消息中心',
            keepAlive: true
        },
        component: index
    },
]
